import { Controller, useForm } from 'react-hook-form'

// MUI
import { Alert, Box, Button, Container, Link, Snackbar, TextField, Typography } from '@mui/material'
import Logo from '../img/logo.png'
import PasswordRestModal from '../container/PasswordRestModal'
import { useEffect, useState } from 'react'
import { decodeUser, isLogin, loginPassword, setPasswordForFirstLogin, setUser } from '../util/LoginUser'
import PasswordChangeDialog from '../container/PasswordChangeDialog'

const LoginPage =  (props) => {
  const { handleSubmit, control, formState: { errors } } = useForm();
  const [open,setOpen] = useState(false);
  const [changeOpen,setChangeOpen] = useState(false);

  const [resetuser,setResetUser] = useState('');
  const [snackBar,setSnackBar] = useState(false);
  const [errorSnackBar,setErrorSnackBar] = useState(false);
  const [loginErrorMsg,setLoginErrorMsg] = useState("");
  const [session,setSession] = useState({})

  const [loginUser,setLoginUser] = useState();

  const [firstPasswordStatus,setFirstPasswordStatus] = useState();

  useEffect(() =>{
    if(resetuser){
      console.log(resetuser);
      setSnackBar(true);
    }
  },[resetuser])

  useEffect(()=>{
    if(loginUser){
      const res = loginApiCall(loginUser);
      if(res){
        //setChangeOpen(true);
      }else{
        setLoginUser();
        setSession("");
      }

    }
  },[loginUser])

  useEffect(() =>{
    if(firstPasswordStatus){
      console.log(firstPasswordStatus);
      firstPasswordChange(firstPasswordStatus);

    }
  },[firstPasswordStatus])

  const firstPasswordChange = async (user) => {
    const res = await setPasswordForFirstLogin(user.password,user.session,user.email);

    if(res.ok){
      const param = {
        email: user.email,
        password: user.password
      }

      loginApiCall(param)
      console.log("login")
    }
    console.log("end");
  };


  const loginApiCall = async (args) => {
      const res = await loginPassword(args);

      //Login Error
      if(res.isError){
        if(res.json?.message){
          setLoginErrorMsg(res.json.message);
        }else{
          setLoginErrorMsg("ログインでエラーが起こりました")
        }
        setErrorSnackBar(true);
        return;
      }

      const json = await res.json;

      if(json.idToken){
        setUser(json);
        await decodeUser();
        props.login(isLogin());
      }else{
        if(json.message == "NEW_PASSWORD_REQUIRED"){
          const ses = await json.session;

          console.log("First Paasword",ses);

          const userInfo = {
            email: args.email,
            session: ses
          }

          setSession(userInfo);
          setChangeOpen(true)

          return ses;
        }
      }

      return;
  };

  const onSubmit = (data) => {
    // props.login(true);
    setLoginUser(data);
  }

  const passwordReset = (data) =>{
    setResetUser(data.email)
    setOpen(false);
  };

  const changePassword = (data) => {
    console.log(data,session);
    // const res = setPasswordForFirstLogin(data.newpassword,session.session,session.email);
    // if(res){
      const user = {
        email: session.email,
        password: data.newpassword,
        session: session.session
      };
      setFirstPasswordStatus(user);
    // }
  }

  return (
    <>
      <Container component='main' >
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img src={Logo} />
        <Typography variant={"body"} sx={{mt:2}}>テナント管理ログイン</Typography>




        <Controller
          name="email"
          control={control}
          rules={{ required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    },
          }}
          render={({ field }) => <TextField
            label="メールアドレス"
            autoFocus={true}
            sx={{mt:4,width: '30%'}}
            {...field}
          />
          }
        />
        {errors.email?.type === 'required' && <Alert sx={{width:'30%'}} severity="warning">
          メールアドレスは必須です。
        </Alert>}
        {errors.email?.type === 'pattern' && <Alert sx={{width:'30%'}} severity="warning">
          メールアドレスの形式が不正です。
        </Alert>}

        <Controller
          name="password"
          control={control}
          rules={{ required: true }}
          render={({ field }) => <TextField
            label="パスワード"
            type={'password'}
            autoFocus={true}
            sx={{mt:3,width: '30%'}}
            {...field}
          />
          }
        />
        {errors.password?.type === 'required' && <Alert sx={{width:'30%'}} severity="warning">
          パスワードは必須です。
        </Alert>}
        <Button
          onClick={handleSubmit(onSubmit)}
          variant='contained'
          sx={{ mt: 3, mb: 2 }}
        >
          <Typography variant={"body1"}>ログイン</Typography>
        </Button>
        <Typography variant='body2'>パスワードを忘れた場合は
        <Link href="#" underline='hover' color="secondary" onClick={(e) => setOpen(true)} >こちら</Link>
        から手続きしてください</Typography>
      </Box>

      </Container>
      <PasswordRestModal open={open} setOpen={setOpen} process={passwordReset} />
      <PasswordChangeDialog open={changeOpen} setOpen={setChangeOpen} process={changePassword} />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={snackBar}
        onClose={()=>{setSnackBar(false)}}
        message="パスワードリセットのリクエストが送信されました"
        key='passwordreset'
      />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={errorSnackBar}
        onClose={()=>{setErrorSnackBar(false)}}
        message={loginErrorMsg}
        key='fetcherror'
      />

    </>
  );

}

export default LoginPage